import React from "react";
import { Link } from "react-router-dom";
import { formations } from "../data/mockData";
import { CarteFormation } from "./CarteFormation";

export const Formations = () => (
  <section id="formations" className="section">
    <div className="shell">
      <div className="mx-auto max-w-[840px] text-center">
        <h2 className="h2">
          Un catalogue court, tenu par des <em>praticiens</em>
        </h2>
        <p className="lede mt-6">
          Sessions en présentiel à Gatineau ou à distance, en petits groupes,
          sur vos propres jeux de données lorsque c'est pertinent.
        </p>
      </div>

      <div className="mt-10 lg:mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {formations.map((formation) => (
          <CarteFormation key={formation.id} formation={formation} />
        ))}
      </div>

      <div className="mt-10 flex justify-center">
        <Link to="/formations" className="btn-outline">
          Tout le catalogue
        </Link>
      </div>
    </div>
  </section>
);
